// import { useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import Layout, { Container } from "../components/layout";
// import { apiurl } from "../config/config.js";
// import { Link, useSearchParams } from "react-router-dom";
// import { CATEGORY_MAP } from "../json/categoryMap.js";
// import { useUser } from "../config/userProvider.js";

// const TABS = ["total", "created", "assigned", "resolved", "watching"];

// const STATUS_COLORS = {
//   new: "bg-blue-100 text-blue-700",
//   open: "bg-indigo-100 text-indigo-700",
//   in_progress: "bg-yellow-100 text-yellow-700",
//   waiting_customer: "bg-orange-100 text-orange-700",
//   escalated: "bg-red-100 text-red-700",
//   resolved: "bg-green-100 text-green-700",
//   closed: "bg-gray-200 text-gray-700",
//   hold: "bg-purple-100 text-purple-700",
// };

// export default function MyTickets() {
//   const { userData } = useUser();
//   const userObjId = userData?._id;

//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);

//   const [searchParams, setSearchParams] = useSearchParams();

//   /* ---------------- URL PARAMS ---------------- */

//   const activeTab = searchParams.get("tab") || "all";
//   const currentPage = Number(searchParams.get("page")) || 1;
//   const limit = Number(searchParams.get("limit")) || 50;
//   const search = searchParams.get("search") || "";
//   const statusFilter = searchParams.get("status") || "";
//   const priorityFilter = searchParams.get("priority") || "";

//   /* ---------------- UPDATE URL ---------------- */

//   const updateParams = (newParams) => {
//     const updated = {
//       tab: activeTab,
//       page: currentPage,
//       limit,
//       search,
//       status: statusFilter,
//       priority: priorityFilter,
//       ...newParams,
//     };

//     Object.keys(updated).forEach((key) => {
//       if (!updated[key]) delete updated[key];
//     });

//     setSearchParams(updated);
//   };

//   /* ---------------- FETCH (NO TAB SENT) ---------------- */

//   const fetchTickets = async () => {
//     if (!userObjId) return;

//     try {
//       setLoading(true);

//       const res = await axios.get(`${apiurl}/api/cst/my-tickets`, {
//         params: {
//           userObjId,
//           page: currentPage,
//           limit,
//           search,
//           status: statusFilter,
//           priority: priorityFilter,
//         },
//       });

//       setData(res.data);
//     } catch (err) {
//       console.error(err);
//       setData(null);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTickets();
//   }, [userObjId, currentPage, limit, search, statusFilter, priorityFilter]);

//   /* ---------------- MERGE TICKETS ---------------- */

//   const mergedTickets = useMemo(() => {
//     if (!data?.tickets) return [];

//     return [
//       ...(data.tickets.created || []),
//       ...(data.tickets.assigned || []),
//       ...(data.tickets.resolved || []),
//       ...(data.tickets.watching || []),
//     ].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//   }, [data]);

//   /* ---------------- TAB FILTER ---------------- */

//   const tickets = useMemo(() => {
//     if (!data?.tickets) return [];

//     if (activeTab === "all") return mergedTickets;

//     return data.tickets[activeTab] || [];
//   }, [data, activeTab, mergedTickets]);

//   /* ---------------- PAGINATION INFO ---------------- */

//   const totalPages = data?.pagination?.totalPages || 1;
//   const totalCount = data?.counts?.total || 0;

//   /* ---------------- UI ---------------- */

//   return (
//     <Layout>
//       <Container overflow={"overflow-scroll"}>
//         <div className="flex flex-col h-[calc(100vh-80px)]">

//           {/* HEADER */}
//           <div className="bg-white border-b p-6 space-y-6">
//             <div>
//               <h1 className="text-2xl font-bold text-gray-800">
//                 🎫 My Tickets
//               </h1>
//               <p className="text-gray-500 text-sm">
//                 View and manage all your tickets
//               </p>
//             </div>

//             {/* Tabs */}
//             <div className="flex gap-6 border-b">
//               {TABS.map((tab) => (
//                 <button
//                   key={tab}
//                   onClick={() => updateParams({ tab, page: 1 })}
//                   className={`pb-3 capitalize font-medium text-sm ${
//                     activeTab === tab
//                       ? "border-b-2 border-indigo-600 text-indigo-600"
//                       : "text-gray-500"
//                   }`}
//                 >
//                   {tab} ({data?.counts?.[tab] || 0})
//                 </button>
//               ))}
//             </div>

//             {/* Filters */}
//             <div className="flex flex-wrap gap-4">
//               <input
//                 type="text"
//                 placeholder="Search ticket or customer..."
//                 value={search}
//                 onChange={(e) =>
//                   updateParams({ search: e.target.value, page: 1 })
//                 }
//                 className="border rounded-lg px-3 py-2 text-sm w-64"
//               />

//               <select
//                 value={statusFilter}
//                 onChange={(e) =>
//                   updateParams({ status: e.target.value, page: 1 })
//                 }
//                 className="border rounded-lg px-3 py-2 text-sm"
//               >
//                 <option value="">All Status</option>
//                 {Object.keys(STATUS_COLORS).map((s) => (
//                   <option key={s} value={s}>
//                     {s.replace("_", " ")}
//                   </option>
//                 ))}
//               </select>

//               <select
//                 value={priorityFilter}
//                 onChange={(e) =>
//                   updateParams({ priority: e.target.value, page: 1 })
//                 }
//                 className="border rounded-lg px-3 py-2 text-sm"
//               >
//                 <option value="">All Priority</option>
//                 <option value="low">low</option>
//                 <option value="medium">medium</option>
//                 <option value="high">high</option>
//                 <option value="critical">critical</option>
//               </select>

//               <select
//                 className="border rounded"
//                 value={limit}
//                 onChange={(e) =>
//                   updateParams({ limit: Number(e.target.value), page: 1 })
//                 }
//               >
//                 {[50, 100, 500, 1000, 2000].map((n) => (
//                   <option key={n} value={n}>
//                     {n} / page
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>

//           {/* TABLE */}
//           <div className="flex-1 overflow-auto bg-gray-50 p-6">
//             <div className="bg-white rounded-xl border overflow-hidden">
//               <div className="overflow-x-auto">
//                 <table className="w-full text-sm">
//                   <thead className="bg-gray-50 text-gray-600">
//                     <tr>
//                       <th className="px-4 py-3 text-left">Ticket</th>
//                       <th className="px-4 py-3 text-center">Customer</th>
//                       <th className="px-4 py-3 text-center">Category</th>
//                       <th className="px-4 py-3 text-center">Priority</th>
//                       <th className="px-4 py-3 text-center">Status</th>
//                       <th className="px-4 py-3 text-center">Assignee</th>
//                       <th className="px-4 py-3 text-center">Respond</th>
//                       <th className="px-4 py-3 text-center">Created</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {loading ? (
//                       <tr>
//                         <td colSpan="7" className="text-center py-10">
//                           Loading tickets...
//                         </td>
//                       </tr>
//                     ) : tickets.length === 0 ? (
//                       <tr>
//                         <td colSpan="7" className="text-center py-10 text-gray-400">
//                           No tickets found
//                         </td>
//                       </tr>
//                     ) : (
//                       tickets.map((t) => (
//                         <tr key={t._id} className="border-b hover:bg-gray-50">
//                           <td className="px-4 py-3">
//                             <Link
//                               target="_blank"
//                               to={`/tickets/${t._id}`}
//                               className="font-medium text-indigo-600"
//                             >
//                               #{t.ticketId}
//                             </Link>
//                           </td>
//                           <td className="px-4 py-3 text-center">
//                             {t.customer?.name || "-"}
//                           </td>
//                           <td className="px-4 py-3 text-center">
//                             {CATEGORY_MAP[t.category]?.label || t.category}
//                           </td>
//                           <td className="px-4 py-3 text-center capitalize">
//                             {t.priority}
//                           </td>
//                           <td className="px-4 py-3 text-center">
//                             <span
//                               className={`px-2 py-1 rounded-full text-xs font-medium ${
//                                 STATUS_COLORS[t.status] ||
//                                 "bg-gray-100 text-gray-700"
//                               }`}
//                             >
//                               {t.status?.replace("_", " ")}
//                             </span>
//                           </td>
//                           <td className="px-4 py-3 text-center">
//                             {t.assignee?.userName || "Unassigned"}
//                           </td>
//                                    <td className="">
//                           {t.departmentActions?.length > 0 ? (
//                             (() => {
//                               const respondedDepts = t.departmentActions.filter(
//                                 (dept) => dept.status === "responded",
//                               );

//                               if (respondedDepts.length > 0) {
//                                 return (
//                                   <div className="flex flex-col text-center gap-1">
//                                     {respondedDepts.map((dept) => (
//                                       <span
//                                         key={dept._id}
//                                         className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700"
//                                       >
//                                         {dept.department} - responded
//                                       </span>
//                                     ))}
//                                   </div>
//                                 );
//                               }

//                               return (
//                                 <span className="text-center flex justify-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
//                                   Pending
//                                 </span>
//                               );
//                             })()
//                           ) : (
//                             <span className="text-center flex justify-center px-2 py-1  text-gray-400 text-xs">—</span>
//                           )}
//                         </td>

//                           <td className="px-4 py-3 text-center">
//                             {new Date(t.createdAt).toLocaleDateString()}
//                           </td>
//                         </tr>
//                       ))
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               {/* PAGINATION */}
//               <div className="flex justify-between items-center px-6 py-4 border-t bg-white">
//                 <div className="text-sm text-gray-500">
//                   Showing {tickets.length} of {totalCount} tickets
//                 </div>

//                 <div className="flex gap-2">
//                   <button
//                     disabled={currentPage <= 1}
//                     onClick={() => updateParams({ page: currentPage - 1 })}
//                     className="px-3 py-1 border rounded disabled:opacity-50"
//                   >
//                     Prev
//                   </button>

//                   <span className="px-3 py-1 text-sm">
//                     Page {currentPage} of {totalPages}
//                   </span>

//                   <button
//                     disabled={currentPage >= totalPages}
//                     onClick={() => updateParams({ page: currentPage + 1 })}
//                     className="px-3 py-1 border rounded disabled:opacity-50"
//                   >
//                     Next
//                   </button>
//                 </div>
//               </div>

//             </div>
//           </div>
//         </div>
//       </Container>
//     </Layout>
//   );
// }
import { useEffect, useState } from "react";
import axios from "axios";
import Layout, { Container } from "../components/layout";
import { apiurl } from "../config/config.js";
import { Link, useSearchParams } from "react-router-dom";
import { CATEGORY_MAP } from "../json/categoryMap.js";
import { useUser } from "../config/userProvider.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const STATUS_COLORS = {
  new: "bg-blue-100 text-blue-700",
  open: "bg-indigo-100 text-indigo-700",
  in_progress: "bg-yellow-100 text-yellow-700",
  waiting_customer: "bg-orange-100 text-orange-700",
  escalated: "bg-red-100 text-red-700",
  resolved: "bg-green-100 text-green-700",
  closed: "bg-gray-200 text-gray-700",
  hold: "bg-purple-100 text-purple-700",
};

export default function MyTickets() {
  const { userData } = useUser();
  const userObjId = userData?._id;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();

  /* ================= URL PARAMS ================= */

  const currentPage = Number(searchParams.get("page")) || 1;
  const limit = Number(searchParams.get("limit")) || 50;

  const search = searchParams.get("search") || "";
  const status = searchParams.get("status") || "";
  const priority = searchParams.get("priority") || "";
  const category = searchParams.get("category") || "";
  const subcategory = searchParams.get("subcategory") || "";
  const acptCategory = searchParams.get("acptCategory") || "";
  const acptError = searchParams.get("acptError") || "";
  const departmentStatus = searchParams.get("departmentStatus") || "";
  const startDate = searchParams.get("startDate") || "";
  const endDate = searchParams.get("endDate") || "";

  /* ================= URL UPDATE ================= */

  const updateParams = (newParams) => {
    const updated = {
      page: currentPage,
      limit,
      search,
      status,
      priority,
      category,
      subcategory,
      acptCategory,
      acptError,
      departmentStatus,
      startDate,
      endDate,
      ...newParams,
    };

    Object.keys(updated).forEach((k) => {
      if (!updated[k]) delete updated[k];
    });

    setSearchParams(updated);
  };

  const clearFilters = () => {
    setSearchParams({});
  };

  /* ================= FETCH ================= */

  const fetchTickets = async () => {
    if (!userObjId) return;

    try {
      setLoading(true);

      const res = await axios.get(`${apiurl}/api/cst/my-tickets`, {
        params: {
          userObjId,
          page: currentPage,
          limit,
          search,
          status,
          priority,
          category,
          subcategory,
          acptCategory,
          acptError,
          departmentStatus,
          startDate,
          endDate,
        },
      });

      setData(res.data);
    } catch (err) {
      console.error(err);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, [searchParams, userObjId]);

  const tickets = data?.tickets || [];
  const totalPages = data?.pagination?.totalPages || 1;
  const totalCount = data?.pagination?.totalTickets || 0;
  const counts = data?.counts || {};

  /* ================= UI ================= */

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="flex flex-col h-[calc(100vh-80px)]">

          {/* HEADER */}
          <div className="bg-white border-b p-2 space-y-4">
          <div className="flex justify-between items-center">
            <h1 className="text-2xl font-bold">🎫 My Tickets</h1>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {["total", "created", "assigned", "resolved", "watching"].map(
                (k) => (
                  <div
                    key={k}
                    className="bg-gray-50 border rounded-lg p-1 text-center"
                  >
                    <p className="text-xs text-gray-500 uppercase">{k}</p>
                    <p className="text-lg font-bold">{counts[k] || 0}</p>
                  </div>
                )
              )}
            </div>
          </div>


            {/* COUNT CARDS */}

            {/* FILTER BAR */}
            <div className="bg-gray-50 border rounded-xl p-4 space-y-3">
              <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
                            <input
                value={search}
                onChange={(e) =>
                  updateParams({ search: e.target.value, page: 1 })
                }
                placeholder="Search ticket / customer..."
                className="w-full border rounded-lg px-3 py-2 text-sm"
              />

                <Select
                  label="Status"
                  value={status}
                  onChange={(v) => updateParams({ status: v, page: 1 })}
                  options={Object.keys(STATUS_COLORS)}
                />

                <Select
                  label="Priority"
                  value={priority}
                  onChange={(v) => updateParams({ priority: v, page: 1 })}
                  options={["low", "medium", "high", "critical"]}
                />

                <Select
                  label="Category"
                  value={category}
                  onChange={(v) =>
                    updateParams({
                      category: v,
                      subcategory: "",
                      page: 1,
                    })
                  }
                  options={Object.keys(CATEGORY_MAP)}
                  renderLabel={(k) => CATEGORY_MAP[k].label}
                />

                {category && (
                  <Select
                    label="Subcategory"
                    value={subcategory}
                    onChange={(v) =>
                      updateParams({ subcategory: v, page: 1 })
                    }
                    options={
                      CATEGORY_MAP[category]?.subs?.map((s) => s.key) || []
                    }
                  />
                )}


              {/* ACPT + DATE */}
                              <Select
                  label="Dept Status"
                  value={departmentStatus}
                  onChange={(v) =>
                    updateParams({ departmentStatus: v, page: 1 })
                  }
                  options={[
                    "pending",
                    "in_progress",
                    "responded",
                    "no_response",
                  ]}
                />


                <Select
                  label="ACPT Category"
                  value={acptCategory}
                  onChange={(v) =>
                    updateParams({
                      acptCategory: v,
                      acptError: "",
                      page: 1,
                    })
                  }
                  options={[
                    "incomplete-or-incorrect-information",
                    "fake-order-or-fake-commitment",
                    "miss-punch-or-wrong-product-punch",
                    "refund-or-return-policy-error",
                    "price-manipulation",
                    "other",
                  ]}
                />

                <Select
                  label="ACPT Error"
                  value={acptError}
                  onChange={(v) =>
                    updateParams({ acptError: v, page: 1 })
                  }
                  options={["agent", "customer", "technical", "process"]}
                />

                <DatePicker
                  selected={startDate ? new Date(startDate) : null}
                  onChange={(d) =>
                    updateParams({
                      startDate: d?.toISOString().split("T")[0],
                      page: 1,
                    })
                  }
                  placeholderText="Start Date"
                  className="border rounded px-3 py-2 text-sm"
                />

                <DatePicker
                  selected={endDate ? new Date(endDate) : null}
                  onChange={(d) =>
                    updateParams({
                      endDate: d?.toISOString().split("T")[0],
                      page: 1,
                    })
                  }
                  placeholderText="End Date"
                  className="border rounded px-3 py-2 text-sm"
                />

                <button
                  onClick={clearFilters}
                  className="px-3 py-2 border rounded text-red-600"
                >
                  Clear
                </button>
              </div>
            </div>
          </div>

          {/* TABLE */}
          <div className="flex-1 overflow-auto bg-gray-50 p-6">
            <div className="bg-white rounded-xl border overflow-hidden">

              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3">Ticket</th>
                    <th>Customer</th>
                    <th>Category</th>
                    <th>Sub category</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Dept Status</th>
                    <th>Deduction</th>
                    <th>Created</th>
                  </tr>
                </thead>

                <tbody>
                  {loading ? (
                    <tr><td colSpan="6" className="text-center py-10">Loading...</td></tr>
                  ) : tickets.length === 0 ? (
                    <tr><td colSpan="6" className="text-center py-10">No tickets found</td></tr>
                  ) : (
                    tickets.map((t) => (
                      <tr key={t._id} className="border-b hover:bg-gray-50">
                        <td className="px-4 py-3">
                          <Link target="_blank" to={`/tickets/${t._id}`} className="text-indigo-600">
                            #{t.ticketId}
                          </Link>
                        </td>
                        <td className="text-center">{t.customer?.name}</td>
                        <td className="text-center">
                          {CATEGORY_MAP[t.category]?.label || t.category}
                        </td>
                          <div className="text-center">
                            {
                              CATEGORY_MAP[t.category]?.subs.find(
                                (s) => s.key === t.subcategory,
                              )?.label
                            }
                          </div>
                        <td className="text-center">{t.priority}</td>
                        <td className="text-center">
                          <span className={`px-2 py-1 rounded ${STATUS_COLORS[t.status]}`}>
                            {t.status}
                          </span>
                        </td>
                                    <td className="">
                          {t.departmentActions?.length > 0 ? (
                            (() => {
                              const respondedDepts = t.departmentActions.filter(
                                (dept) => dept.status === "responded",
                              );

                              if (respondedDepts.length > 0) {
                                return (
                                  <div className="flex flex-wrap justify-center gap-1">
                                    {respondedDepts.map((dept) => (
                                      <span
                                        key={dept._id}
                                        className="px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700"
                                      >
                                        {dept.department} - responded
                                      </span>
                                    ))}
                                  </div>
                                );
                              }

                              return (
                                <span className="px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
                                  Pending
                                </span>
                              );
                            })()
                          ) : (
                            <span className="text-gray-400 text-xs">—</span>
                          )}
                        </td>
                        <td className="">{t?.conductDetails?.conductObjId ?<span className="text-white rounded-md bg-red-600 px-2 py-1">{t?.conductDetails?.deductionAmount}</span> : "N/A"}</td>
                        <td className="text-center">
                          {new Date(t.createdAt).toLocaleDateString()}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              {/* PAGINATION */}
              <div className="flex justify-between p-4 border-t">
                <span>Showing {tickets.length} of {totalCount}</span>

                <div className="flex gap-2">
                  <button
                    disabled={currentPage <= 1}
                    onClick={() => updateParams({ page: currentPage - 1 })}
                    className="px-3 py-1 border rounded"
                  >
                    Prev
                  </button>

                  <span>Page {currentPage} of {totalPages}</span>

                  <button
                    disabled={currentPage >= totalPages}
                    onClick={() => updateParams({ page: currentPage + 1 })}
                    className="px-3 py-1 border rounded"
                  >
                    Next
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
}

function Select({ label, value, onChange, options }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="border rounded-lg px-3 py-2 text-sm capitalize"
    >
      <option value="">{label}</option>
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </select>
  );
}
